import {FieldDescription, FieldLabel, FieldValidation} from "./field/field-description";
import {promptForJumpNumber, validateDropzone, validateNumberField, validateTimestamp} from "./util/validation";
import {shortUnitsName} from "../../util/distance";
import {UnitsContext} from "../../index";
import {dateFormat} from "../../util/time";
import {FORMAT_DATE, FORMAT_DISTANCE, FORMAT_FLOAT} from "./util/format";

const {useContext} = require("react");

const NO_VALIDATION = null;
const NO_PROMPT = null;
const NO_FORMAT = null;

export const JUMP_NUMBER_FIELD = () => {
    return new FieldDescription(
        "jumpNumber",
        new FieldLabel("Jump number", "Required"),
        true,
        NO_FORMAT,
        new FieldValidation(validateNumberField, "Please enter number"),
        new FieldValidation(promptForJumpNumber, "You already have a jump with this number. It is still possible to add it if you want.")
    );
}

export const TITLE_FIELD = () => {
    return new FieldDescription(
        "title",
        new FieldLabel("Title", "Optional"),
        false,
        NO_FORMAT,
        NO_VALIDATION,
        NO_PROMPT
    );
}

export const DATE_FIELD = () => {
    let units = useContext(UnitsContext).units;
    return new FieldDescription(
        "date",
        new FieldLabel("Date", `Required (${dateFormat(units).toUpperCase()})`),
        true,
        FORMAT_DATE,
        new FieldValidation(validateTimestamp, "Please enter valid date"),
        NO_PROMPT // TODO Validate past/future
    );
}

export const DROPZONE_FIELD = () => {
    return new FieldDescription(
        "dropzone",
        new FieldLabel("Dropzone", "Required"),
        true,
        NO_FORMAT,
        new FieldValidation(validateDropzone, "Please choose dropzone"),
        NO_PROMPT
    );
}

export const COMMENT_FIELD = () => {
    return new FieldDescription(
        "comment",
        new FieldLabel("Comment", "Optional"),
        false,
        NO_FORMAT,
        NO_VALIDATION,
        NO_PROMPT
    );
}

export const DISTANCE_FROM_TARGET_FIELD = () => {
    let units = useContext(UnitsContext).units;
    return new FieldDescription(
        "distanceFromTarget",
        new FieldLabel("Landing distance from the target", "Optional", shortUnitsName(units)),
        false,
        FORMAT_DISTANCE,
        new FieldValidation(validateNumberField, "Please enter number"),
        NO_PROMPT
    );
}

export const FREEFALL_TIME_FIELD = () => {
    return new FieldDescription(
        "freeFallTime",
        new FieldLabel("Freefall time", "Optional", "s"),
        false,
        FORMAT_FLOAT,
        new FieldValidation(validateNumberField, "Please enter number"),
        NO_PROMPT
    );
}

export const EXIT_ALTITUDE_FIELD = () => {
    let units = useContext(UnitsContext).units;
    return new FieldDescription(
        "exitAltitude",
        new FieldLabel("Exit altitude", "Optional", shortUnitsName(units)),
        false,
        FORMAT_DISTANCE,
        new FieldValidation(validateNumberField, "Please enter number"),
        NO_PROMPT
    );
}

export const DEPLOY_ALTITUDE_FIELD = () => {
    let units = useContext(UnitsContext).units;
    return new FieldDescription(
        "deployAltitude",
        new FieldLabel("Open altitude", "Optional", shortUnitsName(units)),
        false,
        FORMAT_DISTANCE,
        new FieldValidation(validateNumberField, "Please enter number"),
        NO_PROMPT
    );
}

export const CANOPY_FIELD = () => {
    return new FieldDescription(
        "canopy",
        new FieldLabel("Canopy", "Optional"),
        false,
        NO_FORMAT,
        NO_VALIDATION,
        NO_PROMPT
    );
}

export const AIRCRAFT_FIELD = () => {
    return new FieldDescription(
        "aircraft",
        new FieldLabel("Aircraft", "Optional"),
        false,
        NO_FORMAT,
        NO_VALIDATION,
        NO_PROMPT
    );
}

export const WINGSUIT_FIELD = () => {
    return new FieldDescription(
        "wingsuit",
        new FieldLabel("Wingsuit", "Optional"),
        false,
        NO_FORMAT,
        NO_VALIDATION,
        NO_PROMPT
    );
}